var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"winnow-item-view"},[_c('h3',[_vm._v(_vm._s(_vm.item.name))]),_c('h4',[_vm._v(_vm._s(_vm.item.desc))]),_c('img',{attrs:{"src":_vm.item.img}})])}
var staticRenderFns = []

export { render, staticRenderFns }